(function () {
'use strict';
if (window.__flogomStylist) { return; }
window.__flogomStylist = true;
var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
var CFG = window.flogomChatConfig || {};
var FIND = CFG.findUrl || '/pages/chercher-une-paire';
var SEARCH = CFG.searchUrl || '/search';
var NAME = CFG.stylistName || 'Trouve ma paire';

function el(t, c, x) { var e = document.createElement(t); if (c) { e.className = c; } if (x !== undefined && x !== null) { e.textContent = x; } return e; }
function strip(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
function norm(s) { return strip(s).replace(/[^a-z0-9 ]/g, ' ').replace(/ +/g, ' ').trim(); }
function hit(n, k) { return (' ' + n + ' ').indexOf(' ' + k + ' ') > -1; }
function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
function money(v) { try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR' }).format(v); } catch (e) { return v.toFixed(2) + ' €'; } }
function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }
function inter(a, b) { return a.some(function (x) { return b.indexOf(x) > -1; }); }

var STY = {
  discret: ['samba', 'sambae', 'gazelle', 'gazelle-indoor', 'handball-spezial', 'sl-72', 'campus', 'air-force-1', 'new-balance-550', '550', 'cortez', 'chuck-70'],
  street: ['dunk-low', 'dunk-high', 'jordan-1', 'air-jordan-1-high', 'air-jordan-1-low', 'air-jordan-1-mid', 'air-jordan-4', 'campus-00s', 'gazelle-bold', 'yeezy-boost-350', 'yeezy-quantum', 'nocta', 'jumpman-jack'],
  run: ['gel-1130', 'gel-kayano-14', 'gel-nyc', 'new-balance-2002r', 'new-balance-1906r', 'new-balance-1906d', 'new-balance-9060', 'new-balance-204l', 'new-balance-1000', 'vomero-5', 'air-max', 'shox-tl', 'cloudtilt'],
  cosy: ['tazz', 'tasman', 'ultra-mini', 'boston', 'yeezy-slide', 'yeezy-foam-rnr']
};
var FAM = {
  neutres: ['noir', 'blanc', 'gris', 'beige', 'creme', 'taupe'],
  terre: ['marron', 'beige', 'chestnut', 'bordeaux', 'taupe'],
  bleu: ['bleu', 'bleu marine'],
  vert: ['vert'],
  rose: ['rose', 'violet'],
  vif: ['rouge', 'orange', 'jaune'],
  metal: ['argent', 'or', 'dore'],
  multi: ['multicolore']
};
var COLOR_WORDS = { noir: ['noir'], noire: ['noir'], noirs: ['noir'], blanc: ['blanc'], blanche: ['blanc'], blancs: ['blanc'], blanches: ['blanc'], gris: ['gris'], grise: ['gris'], beige: ['beige'], creme: ['creme'], marron: ['marron', 'chestnut'], bleu: ['bleu'], bleue: ['bleu'], bleus: ['bleu'], bleues: ['bleu'], ciel: ['bleu'], marine: ['bleu marine'], vert: ['vert'], verte: ['vert'], verts: ['vert'], vertes: ['vert'], kaki: ['vert'], rose: ['rose'], roses: ['rose'], rouge: ['rouge'], rouges: ['rouge'], bordeaux: ['bordeaux'], orange: ['orange'], jaune: ['jaune'], violet: ['violet'], violette: ['violet'], mauve: ['violet'], taupe: ['taupe'], argent: ['argent'], argente: ['argent'], argentee: ['argent'], dore: ['dore'], doree: ['dore'], multicolore: ['multicolore'], colore: ['multicolore'], coloree: ['multicolore'] };
var PAL = {
  'bleu': { good: ['blanc', 'creme', 'gris', 'noir'], accent: ['vert', 'bordeaux', 'marron', 'beige'], text: 'Avec du bleu ou du jean, les blancs, crèmes, gris et noirs passent partout. Un beige ou un marron donne un look plus rétro, et un vert ou un bordeaux apporte une touche de couleur.' },
  'bleu marine': { good: ['blanc', 'creme', 'gris', 'beige'], accent: ['bordeaux', 'vert', 'marron'], text: 'Avec du bleu marine, le blanc, la crème et le gris sont des valeurs sûres ; le beige, le bordeaux ou le vert ajoutent du relief.' },
  'noir': { good: ['blanc', 'gris', 'noir'], accent: ['bordeaux', 'rouge', 'bleu', 'rose', 'argent'], text: 'Avec du noir, un blanc ou un gris crée un contraste net. Pour ressortir, tente une touche de couleur (bordeaux, rouge, bleu). Le tout noir marche aussi pour un look discret.' },
  'blanc': { good: ['noir', 'gris', 'beige', 'bleu'], accent: ['vert', 'rose', 'orange'], text: 'Avec du blanc, le noir ou le gris donnent un look net ; le beige ou le bleu restent doux, et une paire colorée (vert, rose, orange) devient la pièce forte de la tenue.' },
  'gris': { good: ['blanc', 'noir', 'bleu'], accent: ['bordeaux', 'vert', 'rose'], text: 'Avec du gris, le blanc et le noir sont des valeurs sûres ; un bleu ou un bordeaux réveille la tenue.' },
  'beige': { good: ['blanc', 'creme', 'marron', 'bleu marine'], accent: ['vert', 'bordeaux'], text: 'Avec du beige, joue la douceur : blanc cassé, crème ou marron. Un vert ou un bordeaux ajoute du contraste sans jurer.' },
  'marron': { good: ['beige', 'creme', 'blanc', 'noir'], accent: ['vert', 'orange', 'bordeaux'], text: 'Avec du marron, les beiges, crèmes et blancs cassés font un look chaud et cohérent ; un vert ou un orange apporte une touche automnale.' },
  'vert': { good: ['beige', 'creme', 'noir', 'blanc'], accent: ['marron', 'orange', 'bordeaux'], text: 'Avec du vert ou du kaki, les neutres (beige, crème, noir, blanc) fonctionnent très bien ; un marron ou un orange donne un look plus outdoor.' },
  'rose': { good: ['blanc', 'creme', 'gris', 'beige'], accent: ['bordeaux', 'vert', 'argent'], text: 'Avec du rose, les neutres clairs (blanc, crème, gris) sont doux ; un argent ou un bordeaux apporte du caractère.' },
  'rouge': { good: ['noir', 'blanc', 'gris'], accent: ['bleu marine'], text: 'Avec du rouge, reste sur des neutres (noir, blanc, gris) pour que la couleur reste la star de la tenue.' },
  'def': { good: ['blanc', 'noir', 'gris', 'beige'], accent: [], text: 'Pour une tenue facile à assortir, les neutres (blanc, noir, gris, beige) vont avec presque tout.' }
};
PAL['creme'] = PAL['beige']; PAL['bordeaux'] = PAL['rouge']; PAL['orange'] = PAL['rouge']; PAL['jaune'] = PAL['rouge']; PAL['violet'] = PAL['rose'];
var GARMENT = { jean: 'bleu', jeans: 'bleu', denim: 'bleu', pantalon: '', cargo: 'vert', chino: 'beige', short: '', bermuda: '', jupe: '', robe: '', jogging: 'gris', survetement: 'gris', survet: 'gris', costume: 'noir', veste: '', pull: '', hoodie: '', sweat: '', manteau: '', tenue: '', look: '', chemise: '', legging: 'noir' };
var GNOTE = { costume: ' Avec un costume, privilégie un modèle sobre en blanc, crème ou noir ; évite les coloris trop voyants.', robe: ' Avec une robe ou une jupe, une paire blanche, crème ou métallisée fait un joli contraste ; les modèles bas et fins (Samba, Gazelle) s’y prêtent bien.', jupe: ' Avec une robe ou une jupe, une paire blanche, crème ou métallisée fait un joli contraste ; les modèles bas et fins (Samba, Gazelle) s’y prêtent bien.', jogging: ' Avec un jogging, un modèle rétro-running ou une Samba / Campus fait très bien.', survetement: ' Avec un jogging, un modèle rétro-running ou une Samba / Campus fait très bien.' };
var MODEL_WORDS = { samba: ['samba', 'sambae'], gazelle: ['gazelle', 'gazelle-bold', 'gazelle-indoor'], campus: ['campus', 'campus-00s'], spezial: ['handball-spezial'], handball: ['handball-spezial'], dunk: ['dunk-low', 'dunk-high'], jordan: ['jordan-1', 'air-jordan-1-high', 'air-jordan-1-low', 'air-jordan-1-mid', 'air-jordan-4', 'jumpman-jack'], yeezy: ['yeezy-boost-350', 'yeezy-foam-rnr', 'yeezy-quantum', 'yeezy-slide'], 'air force': ['air-force-1'], 'air max': ['air-max'], '2002r': ['new-balance-2002r'], '204l': ['new-balance-204l'], kayano: ['gel-kayano-14'], shox: ['shox-tl'], vomero: ['vomero-5'], tazz: ['tazz'], tasman: ['tasman'] };
var BRAND_WORDS = { nike: 'nike', adidas: 'adidas', asics: 'asics', 'new balance': 'new balance', ugg: 'ugg', converse: 'converse', birkenstock: 'birkenstock', 'on running': 'on running' };
var BAD = ['labubu', 'pop mart', 'blind box', 'the monsters', 'pin for love'];
var MARK = { moins: 1, sous: 1, max: 1, maximum: 1, budget: 1, jusqu: 1 };
var HINT = ' Ajoute « homme » ou « femme » pour affiner.';

var CAT = null; var catP = null;
function prep(p) {
  var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
  var tl = tags.map(function (t) { return strip(t).trim(); });
  for (var i = 0; i < BAD.length; i++) { if (tl.indexOf(BAD[i]) > -1) { return null; } }
  var av = (p.variants || []).filter(function (v) { return v.available; });
  if (!av.length) { return null; }
  var colors = []; var models = [];
  tl.forEach(function (t) { if (t.indexOf('couleur:') === 0) { colors.push(t.slice(8)); } else if (t.indexOf('modele:') === 0) { models.push(t.slice(7)); } });
  var title = p.title || ''; var tlow = title.toLowerCase();
  var img = (p.images && p.images[0] && p.images[0].src) || '';
  return { title: title, url: ROOT + 'products/' + p.handle, img: img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '', price: Math.min.apply(null, av.map(function (v) { return parseFloat(v.price); })), sizes: av.map(function (v) { return String(v.option1 || v.title); }), colors: colors, models: models, tagsL: tl, women: tl.indexOf('femme') > -1 || tlow.indexOf('(w)') > -1, kids: tl.indexOf('junior') > -1 || tlow.indexOf('enfant') > -1 || tlow.indexOf('(kids)') > -1, date: p.published_at || p.created_at || '' };
}
function loadCat() {
  if (CAT) { return Promise.resolve(CAT); }
  if (!catP) {
    var all = [];
    var page = function (n) { return fetch(ROOT + 'products.json?limit=250&page=' + n, { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) { throw new Error('cat'); } return r.json(); }).then(function (d) { var ps = d.products || []; all = all.concat(ps); if (ps.length === 250 && n < 4) { return page(n + 1); } return all; }); };
    catP = page(1).then(function (list) { CAT = list.map(prep).filter(Boolean); return CAT; });
    catP.catch(function () { catP = null; });
  }
  return catP;
}

function isSize(t) { return /^[0-9]{2}$/.test(t) && +t >= 35 && +t <= 49; }
function findColors(n) { var out = []; n.split(' ').forEach(function (t) { if (COLOR_WORDS[t]) { out = out.concat(COLOR_WORDS[t]); } }); return uniq(out); }
function hasGarment(n) { var t = n.split(' '); for (var i = 0; i < t.length; i++) { if (GARMENT[t[i]] !== undefined) { return t[i]; } } return ''; }
function parse(n) {
  var toks = n.split(' ');
  var q = { colors: findColors(n), gender: '', size: '', min: 0, max: 0, models: null, brand: '' };
  var skip = {};
  for (var i = 0; i < toks.length; i++) {
    if (MARK[toks[i]]) { for (var j = i + 1; j < Math.min(i + 4, toks.length); j++) { if (/^[0-9]+$/.test(toks[j]) && +toks[j] >= 30) { q.max = +toks[j]; skip[j] = true; break; } } }
    if (toks[i] === 'plus' && toks[i + 1] === 'de' && /^[0-9]+$/.test(toks[i + 2] || '') && +toks[i + 2] >= 60) { q.min = +toks[i + 2]; skip[i + 2] = true; }
  }
  for (var k = 0; k < toks.length; k++) {
    if (!skip[k] && isSize(toks[k]) && !q.size) { q.size = toks[k]; }
    if (toks[k] === 'femme' || toks[k] === 'femmes' || toks[k] === 'fille') { q.gender = 'f'; }
    if (toks[k] === 'enfant' || toks[k] === 'enfants' || toks[k] === 'junior' || toks[k] === 'kids' || toks[k] === 'garcon') { q.gender = 'k'; }
    if (toks[k] === 'homme' || toks[k] === 'hommes') { q.gender = 'm'; }
  }
  var ms = [];
  Object.keys(MODEL_WORDS).forEach(function (w) { if (hit(n, w)) { ms = ms.concat(MODEL_WORDS[w]); } });
  if (ms.length) { q.models = uniq(ms); }
  Object.keys(BRAND_WORDS).forEach(function (w) { if (hit(n, w)) { q.brand = BRAND_WORDS[w]; } });
  return q;
}

function detect(n) {
  if (/livr|expedi|retour|rembours|colis|paiement|payer|panier|commande|cgv|garantie|promo|donnees|mention|parler|humain|quelqu|contacter|joindre|appeler|telephone|mail/.test(n)) { return null; }
  var colors = findColors(n);
  var garment = hasGarment(n);
  var adv = !!garment || n.indexOf('assort') > -1 || n.indexOf('accord') > -1 || n.indexOf('marier') > -1 || n.indexOf('quelle couleur') > -1 || n.indexOf('quel coloris') > -1 || n.indexOf('quelles couleurs') > -1 || n.indexOf('porter avec') > -1 || n.indexOf('va avec') > -1 || n.indexOf('aller avec') > -1;
  if (adv) { return { type: 'advice', garment: garment }; }
  if (colors.length) { return { type: 'color' }; }
  var guided = /conseil|conseill|recommand|idee|cadeau|choisir|choix|sais pas|hesite|perdu|quoi prendre|que prendre|quelle paire|quel modele|style|tendance|populaire|meilleur/.test(n);
  if (guided && n.indexOf('prix') < 0) { return { type: 'guided' }; }
  if (n.indexOf('nouveaut') > -1) { return { type: 'new' }; }
  return null;
}

function LOG() { return document.querySelector('.flogom-chat__log'); }
function down() { var l = LOG(); if (l) { l.scrollTop = l.scrollHeight; } }
function userMsg(t) { var m = el('div', 'flogom-chat__msg flogom-chat__msg--user'); m.appendChild(el('p', '', t)); LOG().appendChild(m); down(); }
function botMsg(t) { var m = el('div', 'flogom-chat__msg flogom-chat__msg--bot'); m.appendChild(el('p', '', t)); LOG().appendChild(m); down(); return m; }
function typing() { var m = el('div', 'flogom-chat__msg flogom-chat__msg--bot flogom-chat__typing', '…'); LOG().appendChild(m); down(); return m; }
function rm(n) { if (n && n.parentNode) { n.parentNode.removeChild(n); } }
function choices(msg, opts) {
  var w = el('div', 'flogom-stylist__choices');
  opts.forEach(function (o) {
    var b = el('button', 'flogom-chat__chip', o.label); b.type = 'button';
    b.addEventListener('click', function () { var all = w.querySelectorAll('button'); for (var i = 0; i < all.length; i++) { all[i].disabled = true; } b.classList.add('is-picked'); userMsg(o.label); setTimeout(o.fn, 250); });
    w.appendChild(b);
  });
  msg.appendChild(w); down();
}

function sizeMatch(p, size) { for (var i = 0; i < p.sizes.length; i++) { var s = p.sizes[i]; if (s === size || s.indexOf(size + ' ') === 0) { return s; } } return ''; }
function hard(cat, q, opt) {
  return cat.filter(function (p) {
    if (q.gender === 'f' && !p.women) { return false; }
    if (q.gender === 'k' && !p.kids) { return false; }
    if (q.gender === 'm' && (p.women || p.kids)) { return false; }
    if (!q.gender && p.kids) { return false; }
    if (q.size && !opt.noSize && !sizeMatch(p, q.size)) { return false; }
    if (!opt.noBudget && ((q.max && p.price > q.max) || (q.min && p.price < q.min))) { return false; }
    if (q.models && !inter(p.models, q.models)) { return false; }
    if (q.brand && p.tagsL.indexOf(q.brand) < 0) { return false; }
    return true;
  });
}
function scoreOf(p, q) {
  var s = 0; var cs = []; var st = false;
  p.colors.forEach(function (c) { if (q.good && q.good.indexOf(c) > -1) { s += 4; cs.push(c); } else if (q.accent && q.accent.indexOf(c) > -1) { s += 2; cs.push(c); } });
  if (q.style && inter(p.models, q.style)) { s += 3; st = true; }
  return { s: s, cs: uniq(cs), st: st };
}
function pick(list, q, level) {
  var needColor = q.good && q.good.length && level < 2; var needStyle = q.style && level < 1;
  var sc = list.map(function (p) { return { p: p, sc: scoreOf(p, q) }; }).filter(function (x) { return (!needColor || x.sc.cs.length) && (!needStyle || x.sc.st); });
  sc.sort(function (a, b) { return b.sc.s - a.sc.s || b.p.sizes.length - a.p.sizes.length; });
  return sc;
}
function recommend(cat, q, maxLevel) {
  var attempts = [{}, { noSize: true }, { noBudget: true }, { noSize: true, noBudget: true }];
  var noteA = ['', 'Je n’ai rien dans cette pointure avec ces critères : voici les plus proches (autres pointures disponibles).', 'Rien dans ce budget avec ces critères : voici les plus proches (budget dépassé).', 'Rien avec tous ces critères : voici les plus proches (autre pointure et budget dépassé).'];
  var noteL = ['', 'Peu de paires exactes dans ce style : voici les plus proches (même coloris).', 'Je n’ai rien dans ces coloris avec tes critères : voici ce qui s’en rapproche.'];
  for (var a = 0; a < attempts.length; a++) {
    var l = hard(cat, q, attempts[a]);
    for (var lv = 0; lv <= maxLevel; lv++) {
      var items = pick(l, q, lv);
      if (items.length >= (lv < maxLevel ? 2 : 1)) { return { items: items, note: (noteA[a] + ' ' + noteL[lv]).trim() }; }
    }
  }
  return { items: [], note: '' };
}
function labels(a) { return a.map(function (c) { return cap(c === 'dore' ? 'doré' : c === 'creme' ? 'crème' : c); }).join(', '); }

function showItems(all, q, offset, intro) {
  var part = all.slice(offset, offset + 4);
  var m = el('div', 'flogom-chat__msg flogom-chat__msg--bot flogom-chat__msg--wide');
  m.appendChild(el('p', '', intro));
  var ul = el('ul', 'flogom-chat__prods');
  part.forEach(function (it) {
    var p = it.p; var li = el('li'); var a = el('a', 'flogom-chat__prod'); a.href = p.url;
    if (p.img) { var im = document.createElement('img'); im.src = p.img; im.alt = ''; im.width = 52; im.height = 52; im.loading = 'lazy'; a.appendChild(im); }
    var box = el('span', 'flogom-chat__prod-box');
    box.appendChild(el('span', 'flogom-chat__prod-title', p.title));
    box.appendChild(el('span', 'flogom-chat__prod-meta', money(p.price)));
    var why = []; if (it.sc.cs.length) { why.push('Coloris ' + labels(it.sc.cs)); } if (it.sc.st) { why.push('dans ton style'); }
    if (why.length) { box.appendChild(el('span', 'flogom-chat__prod-meta is-ok', cap(why.join(' · ')))); }
    var sz = q.size ? sizeMatch(p, q.size) : '';
    box.appendChild(el('span', 'flogom-chat__prod-meta', sz ? 'Pointure ' + sz + ' disponible' : 'Pointures dispo : ' + p.sizes.slice(0, 8).join(', ') + (p.sizes.length > 8 ? '…' : '')));
    a.appendChild(box); li.appendChild(a); ul.appendChild(li);
  });
  m.appendChild(ul);
  LOG().appendChild(m); down();
  var opts = [];
  if (offset + 4 < all.length) { opts.push({ label: 'Voir d’autres (' + (all.length - offset - 4) + ')', fn: function () { showItems(all, q, offset + 4, 'D’autres idées :'); } }); }
  opts.push({ label: NAME, fn: startGuided });
  choices(m, opts);
}
function noResult() {
  var m = botMsg('Je ne trouve pas de paire en stock avec ces critères. Essaie avec un budget plus large ou une autre pointure, ou demande-nous une recherche sur mesure : on la cherche pour toi.');
  var w = el('div', 'flogom-chat__links'); var a = el('a', 'flogom-chat__link', 'Chercher une paire'); a.href = FIND; w.appendChild(a); m.appendChild(w);
}
function fail() { botMsg('Je n’arrive pas à charger le catalogue pour le moment. Tu peux parcourir les paires directement sur le site, ou nous écrire.'); }

var S = {};
function startGuided() {
  S = {};
  var m = botMsg('Avec plaisir, je te guide ! Quelques questions rapides et je te propose des paires en stock qui te correspondent. D’abord : c’est pour qui ?');
  choices(m, [
    { label: 'Homme / mixte', fn: function () { S.gender = 'm'; qStyle(); } },
    { label: 'Femme', fn: function () { S.gender = 'f'; qStyle(); } },
    { label: 'Enfant', fn: function () { S.gender = 'k'; qStyle(); } },
    { label: 'Peu importe', fn: function () { qStyle(); } }
  ]);
}
function qStyle() {
  var m = botMsg('Quel style te parle le plus ? Discret au quotidien (Samba, Gazelle, Campus…), streetwear (Dunk, Jordan, Yeezy…), rétro-running (ASICS, New Balance, Air Max…) ou cosy (UGG, Birkenstock…).');
  choices(m, [
    { label: 'Discret au quotidien', fn: function () { S.style = STY.discret; qColor(); } },
    { label: 'Streetwear', fn: function () { S.style = STY.street; qColor(); } },
    { label: 'Rétro-running', fn: function () { S.style = STY.run; qColor(); } },
    { label: 'Cosy / confort', fn: function () { S.style = STY.cosy; qColor(); } },
    { label: 'Surprends-moi', fn: function () { qColor(); } }
  ]);
}
function qColor() {
  var m = botMsg('Quelles couleurs aimes-tu ? (Tu peux aussi me décrire ta tenue à la fin, par exemple « jean noir et pull beige », pour que je te conseille les coloris qui s’y marient.)');
  function c(label, fam) { return { label: label, fn: function () { if (fam) { S.good = FAM[fam]; } qBudget(); } }; }
  choices(m, [c('Neutres', 'neutres'), c('Terre (marron, beige)', 'terre'), c('Bleu', 'bleu'), c('Vert', 'vert'), c('Rose / violet', 'rose'), c('Rouge / orange / jaune', 'vif'), c('Métallisé', 'metal'), c('Multicolore', 'multi'), c('Peu importe', '')]);
}
function qBudget() {
  var m = botMsg('Quel budget ?');
  function b(label, min, max) { return { label: label, fn: function () { S.min = min; S.max = max; qSize(); } }; }
  choices(m, [b('Moins de 100 €', 0, 100), b('100 à 150 €', 100, 150), b('150 à 250 €', 150, 250), b('Plus de 250 €', 250, 0), b('Peu importe', 0, 0)]);
}
function qSize() {
  var m = botMsg('Et ta pointure (taille européenne) ?');
  var opts = ['36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46'].map(function (s) { return { label: s, fn: function () { S.size = s; finish(); } }; });
  opts.push({ label: 'Je ne sais pas', fn: function () { finish(); } });
  choices(m, opts);
}
function finish() {
  var t = typing();
  loadCat().then(function (cat) {
    rm(t);
    var q = { gender: S.gender || '', size: S.size || '', min: S.min || 0, max: S.max || 0, models: null, brand: '', good: S.good || null, accent: [], style: S.style || null };
    var r = recommend(cat, q, 2);
    if (!r.items.length) { noResult(); return; }
    showItems(r.items, q, 0, r.note ? r.note : 'Voici mes suggestions pour toi :');
  }).catch(function () { rm(t); fail(); });
}

function describe(q) { var d = []; if (q.colors && q.colors.length) { d.push(labels(q.colors).toLowerCase()); } if (q.size) { d.push('pointure ' + q.size); } if (q.max) { d.push('moins de ' + q.max + ' €'); } return d.join(', '); }
function runColor(n) {
  var q = parse(n); q.good = q.colors; q.accent = []; q.style = null;
  var t = typing();
  loadCat().then(function (cat) {
    rm(t);
    var r = recommend(cat, q, 0);
    if (!r.items.length) { noResult(); return; }
    showItems(r.items, q, 0, 'Voici des paires en stock (' + describe(q) + ')' + (r.note ? '. ' + r.note : ' :') + (q.gender ? '' : HINT));
  }).catch(function () { rm(t); fail(); });
}
function runAdvice(n, garment) {
  var q = parse(n); var key = 'def';
  var cols = q.colors;
  if (cols.indexOf('bleu marine') > -1) { key = 'bleu marine'; } else if (cols.length && PAL[cols[0]]) { key = cols[0]; } else if (garment && GARMENT[garment] && PAL[GARMENT[garment]]) { key = GARMENT[garment]; }
  var pal = PAL[key];
  q.good = pal.good; q.accent = pal.accent; q.style = null; q.models = null; q.brand = '';
  botMsg('Ce sont des pistes, pas des règles : ' + pal.text + (GNOTE[garment] || ''));
  var t = typing();
  loadCat().then(function (cat) {
    rm(t);
    var r = recommend(cat, q, 2);
    if (!r.items.length) { noResult(); return; }
    showItems(r.items, q, 0, 'Dans ton stock, voici des paires qui iraient bien' + (q.size ? ' (pointure ' + q.size + ')' : '') + (q.max ? ' sous ' + q.max + ' €' : '') + ' :' + (q.gender ? '' : HINT));
  }).catch(function () { rm(t); fail(); });
}
function runNew(n) {
  var q = parse(n); q.good = null; q.accent = []; q.style = null;
  var t = typing();
  loadCat().then(function (cat) {
    rm(t);
    var l = hard(cat, q, {});
    l.sort(function (a, b) { return a.date < b.date ? 1 : -1; });
    if (!l.length) { noResult(); return; }
    showItems(l.map(function (p) { return { p: p, sc: { cs: [], st: false, s: 0 } }; }), q, 0, 'Les dernières arrivées en stock :');
  }).catch(function () { rm(t); fail(); });
}
function handle(d, n) {
  if (d.type === 'guided') { startGuided(); return; }
  if (d.type === 'color') { runColor(n); return; }
  if (d.type === 'advice') { runAdvice(n, d.garment); return; }
  if (d.type === 'new') { runNew(n); }
}

function hook() {
  var panel = document.getElementById('flogom-chat-panel');
  if (!panel) { return false; }
  if (panel.getAttribute('data-stylist')) { return true; }
  panel.setAttribute('data-stylist', '1');
  panel.addEventListener('submit', function (e) {
    var input = panel.querySelector('.flogom-chat__input');
    var v = (input.value || '').trim();
    if (!v) { return; }
    var n = norm(v); var d = detect(n);
    if (!d) { return; }
    e.preventDefault(); e.stopPropagation();
    input.value = '';
    userMsg(v);
    handle(d, n);
  }, true);
  var chips = panel.querySelector('.flogom-chat__chips');
  if (chips) {
    var c2 = el('button', 'flogom-chat__chip', 'Quelle couleur choisir ?'); c2.type = 'button';
    c2.addEventListener('click', function () { userMsg('Quelle couleur choisir ?'); botMsg('Décris-moi ta tenue et je te dis quels coloris s’y marient. Par exemple : « jean noir et pull beige », « robe blanche » ou « costume gris ». Tu peux ajouter ta pointure, ton budget ou « femme » / « homme » pour affiner.'); });
    chips.insertBefore(c2, chips.firstChild);
    var c1 = el('button', 'flogom-chat__chip', NAME); c1.type = 'button';
    c1.addEventListener('click', function () { userMsg(NAME); startGuided(); });
    chips.insertBefore(c1, chips.firstChild);
  }
  return true;
}
var tries = 0;
var iv = setInterval(function () { if (hook() || ++tries > 100) { clearInterval(iv); } }, 150);
})();
